export type User = {
  id: string;
  attributes: {
    name: string;
    email: string;
    device_groups: string[];
    labels: string[];
    workspaces: string[];
    roles: string[];
    configuration: {
      receive_monthly_report: boolean;
      receive_weekly_report: boolean;
      receive_daily_report: boolean;
      allow_edit_shared_devices?: boolean;
    };
  };
};
export const DEVICE_TAG_GROUP = 'group';
export const DEVICE_TAG_LABEL = 'label';
export type DeviceTag = {
  guid: string;
  attributes: {
    type: string;
    name: string;
    owner?: null | {
      name: string;
      email?: string;
      guid: string;
    };
    shared: boolean;
    is_ref_of: boolean;
    delivery_configurations: string[];
    parent: string;
    original_tag_guid?: string | null;
  };
};
export type Building = {
  guid: string;
  attributes: {
    type: string;
    name: string;
    shared: boolean;
    is_ref_of: string;
    parent: string;
  };
};

export type AlarmDefinition = {
  guid: string;
  attributes: {
    name: string;
    type: string;
    trigger_def: DeadManTriggerDef | LevelTriggerDef;
    window_def: TimeSpanTimeWindowDef | MeasureCountTimeWindowDef;
    actions: AlarmActionDef[];
  };
};

export type DeadManTriggerDef = {
  type: string;
};
export type LevelTriggerDef = {
  metricName: string;
  type: string;
  level_type: string;
  level: number;
  topLimit: number;
  bottomLimit: number;
};
export const SCHEDULED_ALARM = 'scheduled';
export const NEW_DATA_ALARM = 'on-new-data';

export const METRIC_GOES_BELOW = 'MGB';
export const METRIC_GOES_ABOVE = 'MGA';
export const METRIC_GOES_BETWEEN = 'MGBT';
export const createLevelTriggerDef = (): LevelTriggerDef => {
  return {
    metricName: '',
    type: LEVEL_TRIGGER,
    level_type: METRIC_GOES_BELOW,
    level: 0,
    topLimit: 0,
    bottomLimit: 0
  } as LevelTriggerDef;
};

export const createDeadmanTriggerDef = (): DeadManTriggerDef => {
  return {
    type: DEADMAN_TRIGGER
  } as DeadManTriggerDef;
};

export const prepareTriggerForSending = (trigger: LevelTriggerDef | DeadManTriggerDef) => {
  if (trigger.type === LEVEL_TRIGGER) {
    const t = trigger as LevelTriggerDef;
    return {
      trigger_type: LEVEL_TRIGGER,
      metric_name: t.metricName,
      type: t.level_type,
      level: t.level,
      top_limit: t.topLimit,
      bottom_limit: t.bottomLimit
    };
  }

  return {
    trigger_type: DEADMAN_TRIGGER
  };
};
export type TimeSpanTimeWindowDef = {
  type: string;
  timeUnits: string;
  span: number;
};

export const createTimeSpanTimeWindowDef = () => {
  return {
    type: 'timespan',
    timeUnits: 'd',
    span: 0
  } as TimeSpanTimeWindowDef;
};

export type MeasureCountTimeWindowDef = {
  measureCount: number;
  type: string;
};

export const createMeasureCountTimeWindowDef = () => {
  return {
    type: 'measure_count',
    measureCount: 0
  } as MeasureCountTimeWindowDef;
};

export const prepareTimeWindowForSending = (
  tw: TimeSpanTimeWindowDef | MeasureCountTimeWindowDef
) => {
  if (tw.type === TimeSpanAlarmType) {
    const t = tw as TimeSpanTimeWindowDef;
    return {
      type: t.type,
      units: t.timeUnits,
      span: t.span
    };
  }
  if (tw.type === MeasureCountAlarmType) {
    const t = tw as MeasureCountTimeWindowDef;
    return {
      type: t.type,
      measure_count: t.measureCount
    };
  }
};

export type AlarmActionDef = {
  type: string;
  notify_alarm: boolean;
  notify_back_to_nomal: boolean;
  measureCount: number;
};

export const prepareAlarmActionsForSending = (actions: AlarmActionDef[]) => {
  return actions.map((a: AlarmActionDef) => {
    return {
      action_type: a.type,
      notify_alarm: a.notify_alarm,
      notify_back_to_normal: a.notify_back_to_nomal
    };
  });
};

export const MeasureCountAlarmType = 'measure_count';
export const TimeSpanAlarmType = 'timespan';
export const DEADMAN_TRIGGER = 'deadman';
export const LEVEL_TRIGGER = 'level';
export const EMAIL_ALARM_ACTION = 'email-notification';

export type DeviceType = {
  guid: string;
  type: string;
  attributes: {
    name: string;
    input_data_names: string[];
    output_data_names: string[];
    featured_data_names: string[];
    parameter_definitions: DeviceTypeParameter[];
  };
};

export const BOOLEAN_PARAMETER_TYPE = 'boolean';
export const TEXT_PARAMETER_TYPE = 'text';
export const TEXTAREA_PARAMETER_TYPE = 'textarea';
export const SELECT_PARAMETER_TYPE = 'select';
export const STATIC_IMAGE_PARAMETER_TYPE = 'static-image';
export const INT_PARAMETER_TYPE = 'int';
export const FLOAT_PARAMETER_TYPE = 'float';
export const DATE_PARAMETER_TYPE = 'date';

export type DeviceTypeParameter = {
  identifier: string;
  label: string;
  type: string;
  projectable: boolean;
  options: { [a: string]: string };
};

export const getAvailableMeasureNames = (types: DeviceType[]): string[] => {
  const measures: string[] = [];
  types.forEach((t: DeviceType) => {
    t.attributes.output_data_names.forEach((n: string) => {
      if (!measures.includes(n)) {
        measures.push(n);
      }
    });
  });
  return measures;
};
